import { useAtomValue } from 'jotai';
import { userConfig } from '~/global-state/userConfig';

export function useEsnaEnabled(): boolean {
  const config = useAtomValue(userConfig);
  return config.esnaEnabled;
}
